<strong></strong><template>
  <Modal v-model="show" :title="'业务费用明细编辑'" :mask-closable="false" :closable='false' width="750">
    <Form :model="form" ref="form" :rules="rules" :label-width="130" inline>
	  <FormItem label="时间:" prop="costTime">
	    <DatePicker type="datetime" placeholder="请选择" style="width: 200px"  @on-change="form.costTime = $event" :value="form.costTime" />
	  </FormItem>
	  <FormItem label="业务员：" prop="salesman">
	  		  <Select v-model="form.salesman" style="width:200px">
	  			  <Option v-for="item in salesmanData" :value="item.value" :key="item.value">{{ item.name }}</Option>
	  		  </Select>
	  </FormItem>
	  <FormItem label="节日礼品金额：" prop="holidayGiftAmount">
	    <Input type="number" placeholder="请输入" v-model="form.holidayGiftAmount" style="width: 200px;"></Input>
	  </FormItem>
	  <FormItem label="业务费：" prop="operatingAmount">
	    <Input type="number" placeholder="请输入" v-model="form.operatingAmount" style="width: 200px;"></Input>
	  </FormItem>
	  <FormItem label="商务活动：" prop="businessActivityAmount">
	    <Input type="number" placeholder="请输入" v-model="form.businessActivityAmount" style="width: 200px;"></Input>
	  </FormItem>
	  <FormItem label="小计：" prop="subtotal">
	    <Input type="number" placeholder="请输入" v-model="form.subtotal" style="width: 200px;"></Input>
	  </FormItem>
	  <FormItem label="目的：" prop="objective">
	    <Input type="textarea" placeholder="请输入" v-model="form.objective" style="width: 540px"></Input>
	  </FormItem>
    </Form>
    <Spin size="large" fix v-show="spinShow"></Spin>
    <div slot="footer">
      <Button @click="close()" class="close-btn">关闭</Button>
      <Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn">提交</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'CreateBid',
  props: {
    show: Boolean, //弹窗 窗口显示
    customerSEBId: Number,
	detailId: Number,
	departmentType:Number
  },
  data() {
    return {
      form: {
		holidayGiftAmount:null,
		operatingAmount:null,
		businessActivityAmount:null,
		subtotal:null,  
	    salesman:null,
		costTime:'',
		objective:'',
        customerSEBId: this.customerSEBId,
		id:this.detailId
      },
      rules: {
        salesman: [{ required: true, message: '请选择', trigger: 'blur,change', type: 'number' }],
		costTime: [
		  { required: true, message: '请选择', trigger: 'blur'},
		],
		holidayGiftAmount:[{ required: true, message: '节日礼品金额不能为空',},{ message: '节日礼品金额只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}],
		operatingAmount:[{ required: true, message: '业务费不能为空',},{ message: '业务费只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}],
		businessActivityAmount:[{ required: true, message: '商务活动不能为空',},{ message: '商务活动只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}],
      },
      salesmanData: [], //
      customerJMData: [], //
	  companyName:'',
      spinShow: false,
	  hasCustomer:false,
	  isDisabled:false,
    }
  },
  mounted() {
	this.getUser()
    
  },
  methods: {
    // 关闭弹窗
    close(refresh) {
	  this.form={
	    holidayGiftAmount:null,
	    operatingAmount:null,
	    businessActivityAmount:null,
	    subtotal:null,  
	    salesman:null,
	    costTime:null,
	    objective:'',
	    customerSEBId: this.customerSEBId,
		id:0
      }
      this.$refs['form'].resetFields()
      this.$emit('close', refresh)
    },
    //   提交记录
    submit() {
      let _this = this
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
			let files = []
          this.spinShow = true
		  var url=''
		  if(this.form.id!=null && this.form.id!=0){
		     url='/api/services/app/CustomerSalesExpenseBudgetDetailApiService/Update'
			 let { data } = await this.$Ajax.put(
			   url,
			   this.form
			 )
			 if (data.success) {
			   this.$Message.success({
			     content: '编辑成功',
			   })
			   _this.close(true)
			 }
		 }
		  else {
		      url='/api/services/app/CustomerSalesExpenseBudgetDetailApiService/Create'
			  let { data } = await this.$Ajax.post(
				url,
				this.form
			  )
			  if (data.success) {
				this.$Message.success({
				  content: '新建成功',
				})
				_this.close(true)
			  }
		  }
          this.spinShow = false
        }
      })
    },
    //   获取下拉框数据
    async getUser() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerSalesExpenseBudgetDetailApiService/GetSalesExpenseBudgetDetailMgrInitData?departmentType=${this.departmentType}`
      )
      this.salesmanData = data.result.salesmanData
	  this.hasCustomer=data.result.hasCustomer
	  if(this.detailId){
	  	this.getDetail()
	  }
    },
	
	async getDetail() {
	  const { data } = await this.$Ajax.get(
	    `/api/services/app/CustomerSalesExpenseBudgetDetailApiService/GetDetailById?id=${this.detailId}`
	  )
	  this.form = data.result
	  if(this.form.isSuccessfulBid){
	  	this.isDisabled=true
	  }
	  else{
	  	this.isDisabled=false
	  }
	  this.spinShow = false
	},
	changeSuccessfulBid(){
		if(this.form.isSuccessfulBid){
			this.isDisabled=true
			this.form.winningBidder = this.companyName
		}
		else{
			this.isDisabled=false
			this.form.winningBidder = ''
		}
	}
  },
}
</script>